<template>
  <v-card flat class="pa-4">
    <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="settings.trackLitres" class="ml-5">
          <span slot="label" v-on="on">Track litres in addition to LAA</span>
        </v-switch>
      </template>
      If enabled, then volume for spirits must be specified everywhere in both litres and LAA.
      This will then let you show tank contents in litres and strength, in addition to LAA.
      The default is to only enter spirit volume in LAA.
    </v-tooltip>
    <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="settings.trackKg" class="ml-5">
          <span slot="label" v-on="on">Track kg in addition to LAA</span>
        </v-switch>
      </template>
      If enabled, then weight for spirits must be specified everywhere LAA is used.
      This will then let you show tank contents in kg, in addition to LAA.
      The default is to only enter spirit volume in LAA.
    </v-tooltip>
    <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="settings.trackStrength" class="ml-5">
          <span slot="label" v-on="on">Track strength in addition to LAA</span>
        </v-switch>
      </template>
      If enabled, then % alc./vol. for spirits must be specified everywhere LAA is used.
      This will then let you show tank strength, in addition to LAA.
      The default is to only enter spirit volume in LAA.
    </v-tooltip>
  </v-card>
</template>

<script>
import settingsPreferences from '@/views/settings/preferences/settingsPreferences'

export default {
  name: 'SettingsPreferencesInventorySpirits',
  mixins: [settingsPreferences]
}
</script>